var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jdi-content',{attrs:{"title":"Spacing & Sizing"}},[_c('p',[_vm._v(" We use a 4 pixel grid system, currently equivalent to the default tailwind settings. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }